import { render, staticRenderFns } from "./guanhuHeader.vue?vue&type=template&id=60a6663d&scoped=true&"
import script from "./guanhuHeader.vue?vue&type=script&lang=js&"
export * from "./guanhuHeader.vue?vue&type=script&lang=js&"
import style0 from "./guanhuHeader.vue?vue&type=style&index=0&id=60a6663d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a6663d",
  null
  
)

export default component.exports